import React, { PropsWithChildren, ReactElement } from "react";

interface Props {
  className?: string;
  onClick: () => void;
}

export function AppSmallTabButton(props: PropsWithChildren<Props>): ReactElement {
  return (
    <div className={["AppSmallTabButton", props.className].join(" ")} onClick={props.onClick}>
      {props.children}
    </div>
  );
}
